import Badge from '@mui/material/Badge'
import Button from '@mui/material/Button'
import SortIcon from '@mui/icons-material/Sort'
import { gridSortModelSelector, useGridApiContext } from '@mui/x-data-grid-pro'

declare module '@mui/x-data-grid-pro' {
  interface GridLocaleText {
    resetSortingButton: string
  }
}

export function DataGridToolbarResetSortingButton() {
  const gridApiRef = useGridApiContext()

  const sortModel = gridSortModelSelector(gridApiRef)

  const handleClick = () => {
    gridApiRef.current.setSortModel([])
  }

  return (
    <Button
      onClick={handleClick}
      size='small'
      startIcon={
        <Badge badgeContent={sortModel.length} color='primary'>
          <SortIcon fontSize='inherit' />
        </Badge>
      }
      variant='text'
    >
      {gridApiRef.current.getLocaleText('resetSortingButton')}
    </Button>
  )
}
